import React from 'react';
import GoogleListingPicker from '../provider/GoogleListingPicker';

interface ProfileData {
  fullName: string;
  phone: string;
  profileImage: File | null;
  profileImageUrl?: string;
  businessName: string;
  licenseNumber: string;
  yearsOfExperience: number;
  bio: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  website: string;
  specialties: string[];
  services: string[];
  treatmentCategories: string[];
  pricingRange: string;
  virtualConsultations: boolean;
  education: Array<{
    degree: string[];
    institution: string;
    year: string;
  }>;
  certifications: Array<{
    name: string[];
    issuer: string;
    year: string;
  }>;
  affiliations: string[];
  insuranceAccepted: string[];
  languagesSpoken: string[];
}

interface Step5PracticeProps {
  data: ProfileData;
  updateData: (updates: Partial<ProfileData>) => void;
  // Null until the provider profile exists; the listing is saved on its own, not on submit
  googleListing?: { placeId: string | null | undefined } | null;
}

const Step5Practice: React.FC<Step5PracticeProps> = ({ data, updateData, googleListing }) => {
  return (
    <div className="space-y-4 sm:space-y-6">
      <h2 className="font-['Ovo',_serif] text-[22px] sm:text-[26px] lg:text-[28px] text-[#1f1f1f] mb-4 sm:mb-6">
        Practice Information
      </h2>

      <div>
        <label className="block mb-2 font-['Open_Sans'] text-sm font-semibold text-[#1f1f1f]">
          Practice Address *
        </label>
        <input
          type="text"
          value={data.address}
          onChange={(e) => updateData({ address: e.target.value })}
          className="w-full px-4 py-3 sm:py-2.5 border border-[#e5e5ea] rounded focus:outline-none focus:border-[#c6a664] text-base"
          placeholder="Street Address"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
        <input
          type="text"
          value={data.city}
          onChange={(e) => updateData({ city: e.target.value })}
          className="px-4 py-3 sm:py-2.5 border border-[#e5e5ea] rounded focus:outline-none focus:border-[#c6a664] text-base"
          placeholder="City"
        />
        <input
          type="text"
          value={data.state}
          onChange={(e) => updateData({ state: e.target.value })}
          className="px-4 py-3 sm:py-2.5 border border-[#e5e5ea] rounded focus:outline-none focus:border-[#c6a664] text-base"
          placeholder="State"
        />
        <input
          type="text"
          value={data.zipCode}
          onChange={(e) => updateData({ zipCode: e.target.value })}
          className="px-4 py-3 sm:py-2.5 border border-[#e5e5ea] rounded focus:outline-none focus:border-[#c6a664] text-base"
          placeholder="ZIP Code"
        />
      </div>

      <div>
        <label className="block mb-2 font-['Open_Sans'] text-sm font-semibold text-[#1f1f1f]">
          Website
        </label>
        <input
          type="url"
          value={data.website}
          onChange={(e) => updateData({ website: e.target.value })}
          className="w-full px-4 py-3 sm:py-2.5 border border-[#e5e5ea] rounded focus:outline-none focus:border-[#c6a664] text-base"
          placeholder="https://www.yourwebsite.com"
        />
      </div>

      <div>
        <label className="block mb-2 font-['Open_Sans'] text-sm font-semibold text-[#1f1f1f]">
          Google Listing
        </label>
        {googleListing ? (
          <GoogleListingPicker placeId={googleListing.placeId} />
        ) : (
          <p className="font-['Open_Sans'] text-sm text-[#767472]">
            You can link your Google listing from your profile once you finish.
          </p>
        )}
      </div>
    </div>
  );
};

export default Step5Practice;
